module.exports = __webpack_public_path__ + "static/media/footer_img.4b44bfad.png";